import { withStyles } from '@material-ui/core'
import { Translation } from 'react-i18next'
import FontAwesome from 'react-fontawesome'

const styles = () => ({
  link: {
    display: 'flex',
    alignItems: 'center'
  }
})

const front = (concept) => {
  switch (concept) {
    case 'ETUSIVU':
      return 'nav2.etu'
    case 'ASIAKKAAT':
      return 'nav2.hin'
    case 'UUSI_LASKUT':
      return 'nav2.uusi_laskut'
    case 'LASKUT':
      return 'nav2.kysy'
    case 'KULUT':
      return 'nav2.kevy'
    case 'PALKAT':
      return 'nav2.yhteys'
    case 'PROFILE':
      return 'dashboard.asetu'
    case 'LUOMASI_LASKUT':
      return 'nav2.createdInvoices'
    case 'OPENFORWORK':
      return 'nav2.openwork'
  }
}

const NavIconHorizontal = ({
  classes,
  name,
  size,
  iconClass,
  content,
  totalNewAssignments,
  totalNewApplications,
  totalNewWorkshifts
}) => (
  <Translation>
    {(t) => {
      return (
        <div className={classes.link}>
          <FontAwesome
            name={name}
            size={size}
            className={iconClass}
            style={{ marginRight: '10px' }}
          />
          <p style={{ margin: '0' }}>{t(front(content))}</p>
          {content === 'OPENFORWORK' &&
            (totalNewAssignments > 0 ||
              totalNewApplications > 0 ||
              totalNewWorkshifts > 0) && (
              <p style={{ position: 'absolute', right: '0', top: '8px' }}>
                <FontAwesome name="circle" />
              </p>
            )}
        </div>
      )
    }}
  </Translation>
)

export default withStyles(styles)(NavIconHorizontal)
